import React from 'react';
import { Button } from 'Components/ui';
import { formatDateOnlyWithTimezone, formatTimeOnlyWithTimezone } from 'utils/date_utils';
import { resolveActionLabel } from './action-label.js';
import { resolveResultWithDetail } from './result-label.js';

export const getTableHeader = (t, companyTimezone, companyLocale, extraColumns = []) => [
  {
    id: 'date',
    type: 'text',
    value: 'Data',
    render: (_value, item) => formatDateOnlyWithTimezone(item.displayTimestamp, companyTimezone, companyLocale),
  },
  {
    id: 'time',
    type: 'text',
    value: 'Hora',
    render: (_value, item) => formatTimeOnlyWithTimezone(item.displayTimestamp, companyTimezone, companyLocale),
  },
  {
    id: 'user',
    type: 'text',
    value: 'Usuário',
  },
  {
    id: 'action',
    type: 'text',
    value: 'Ação',
    render: (_action, item) => resolveActionLabel(t, item),
  },
  {
    id: 'return',
    type: 'text',
    value: 'Resposta',
    render: (_value, item) => resolveResultWithDetail(t, item),
  },
  ...extraColumns,
];

const EyeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

// Trailing per-row view icon that opens AuditLogDetailDialog — same iconOnly/variant="icon"
// Button + eye glyph as the view actions in Cookies, Data and VendorList. Rendered through
// DefaultTable's per-column `render` (like Global's "Empresa" column), not its unused
// showModalDetail hook, so it gets the standardized Button rather than a raw table icon.
export const getDetailColumn = (t, onView) => ({
  id: 'detail',
  type: 'text',
  value: '',
  render: (_value, item) => (
    <Button iconOnly variant="icon" title={t('common:tooltips.view')} onClick={() => onView(item)}>
      <EyeIcon />
    </Button>
  ),
});
